import { render, staticRenderFns } from "./GuarderiaDetail.vue?vue&type=template&id=5335c8f6&scoped=true"
import script from "./GuarderiaDetail.vue?vue&type=script&lang=js"
export * from "./GuarderiaDetail.vue?vue&type=script&lang=js"
import style0 from "./GuarderiaDetail.vue?vue&type=style&index=0&id=5335c8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5335c8f6",
  null
  
)

export default component.exports